import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap'
import { GRID_COLS, GRID_ROW_HEIGHT, LIST_CONTAINER_WIDTH, LIST_WIDTH } from '../../constants/ScriptLogTemplateBuilder'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import ButtonWithLoader from '../ButtonWithLoader'
import ConfirmDialog from '../ConfirmDialog'
import Field from '../ScriptLogTemplate/Field'
import GridLayout from 'react-grid-layout'

const switchStyle = {
  height: 20
}

class Item extends React.PureComponent {
  state = {
    confirmDeleteDialogOpen: false
  }

  fieldsToLayout (fields) {
    return fields.map((field, index) => ({
      i: index.toString(),
      ...field
    }))
  }

  componentDidUpdate () {
    const {save} = this.props.actions

    if (this.saveTimeout) clearTimeout(this.saveTimeout)
    this.saveTimeout = setTimeout(save, 1000)
  }

  handleDeleteButtonClick = () => {
    this.setState({confirmDeleteDialogOpen: true})
  }

  handleConfirmDeleteDialogClose = () => {
    this.setState({confirmDeleteDialogOpen: false})
  }

  handleConfirmDelete = () => {
    this.props.actions.delete()
    this.setState({confirmDeleteDialogOpen: false})
  }

  render () {
    const {template, type, entry, actions, deleteLoading} = this.props
    const {update} = actions

    let heading

    switch (type) {
      case 'scene':
        heading = 'Scene'
        break
      case 'slate':
        heading = 'Slate'
        break
      case 'take':
        heading = 'Take'
        break
      default:
        break
    }

    const list = template.lists[type]

    const layout = this.fieldsToLayout(list.fields)

    return <Card className="script-log-template-box shadow border-0" style={{width: LIST_CONTAINER_WIDTH}}>
      <CardHeader className="bg-default d-flex justify-content-between align-items-center">
        {heading}
        {list.showStatus && <FormControlLabel
          control={
            <Switch
              style={switchStyle}
              checked={entry['complete'] ? true : false}
              onChange={(event, checked) => update('complete', checked)}
            />
          }
          label="Completed"
        />}
      </CardHeader>
      <CardBody>
        <GridLayout
          className="position-relative layout"
          layout={layout}
          cols={GRID_COLS}
          rowHeight={GRID_ROW_HEIGHT}
          width={LIST_WIDTH}
          isDraggable={false}
          isResizable={false}
          compactType="vertical"
        >
          {layout.map(item => {
            return <div key={item.i} className={item.type === 'dropdown' ? 'z-index-20' : ''}>
              <Field
                type={item.type}
                name={item.name}
                label={item.label}
                value={entry[item.name]}
                onChange={value => {
                  update(item.name, value)
                }}
                height={item.h * 63}
                suggestions={item.suggestions}
              />
            </div>
          })}
        </GridLayout>
      </CardBody>
      <CardFooter>
        <div className="d-flex justify-content-end">
          <ButtonWithLoader
            className="ml-2"
            loading={deleteLoading}
            color="red"
            onClick={this.handleDeleteButtonClick}
          >Delete</ButtonWithLoader>

          <ConfirmDialog
            title={`Confirm ${type} Delete`}
            open={this.state.confirmDeleteDialogOpen}
            onClose={this.handleConfirmDeleteDialogClose}
            onConfirm={this.handleConfirmDelete}
          >
            Are you sure you want to delete this {type}?
          </ConfirmDialog>
        </div>
      </CardFooter>
    </Card>
  }
}

Item.propTypes = {
  template: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['scene', 'slate', 'take']).isRequired,
  entry: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    update: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired
  }),
  deleteLoading: PropTypes.bool
}

Item.defaultProps = {
  saveLoading: false,
  deleteLoading: false
}

export default Item



// WEBPACK FOOTER //
// ./components/ScriptLogForm/Item.js